import { render, staticRenderFns } from "./DropList.vue?vue&type=template&id=0d85bdec&scoped=true&"
import script from "./DropList.vue?vue&type=script&lang=js&"
export * from "./DropList.vue?vue&type=script&lang=js&"
import style0 from "./DropList.vue?vue&type=style&index=0&id=0d85bdec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85bdec",
  null
  
)

export default component.exports